import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class PopulateService {
    private _storageCache = {};

    get storageCache() {
        return this._storageCache;
    }

    set storageCache(cache) {
        this._storageCache = cache;
    }
}
